import { AttributeUiType } from './attributeUiType';

export class RankedKeyValues {
  constructor(
    public rank: number,
    public key: string,
    public description: string,
    public values: string[],
    public type?: AttributeUiType
  ) {}

  static parse(data): RankedKeyValues {
    if (!data) return null;
    return new RankedKeyValues(data.rank, data.key, data.description, data.values, data.type);
  }
}
